import React, { Fragment } from 'react';
import { DISTRIBUTION, HAZARDS, LONGITS } from './common';
import ExistingHazards from './existingHazards';
import ExistingLongitudinalHazards from './existingLongitudinalHazards';
import { DownloadIcon, PencilIcon } from '@heroicons/react/solid';


const AllExistingHazards = (props) => {
  const {type, existingHazards, unit, biomarker, onEditClick} = {...props};
  const iconClasses = `text-uhblue-light inline-block cursor-pointer ml-2 h-5 w-5 inline-block 
  border border-uhblue-darkest bg-uhblue-darkest rounded`
  return ( 
      <Fragment>
        
        
        <div className='w-full text-right absolute top-1 right-1'>
          <span className={iconClasses} onClick={onEditClick}>
            <PencilIcon/>
          </span> 
          {
            existingHazards.length > 0 &&
            <span className={iconClasses} onClick={() => {}}>
              <DownloadIcon/>
            </span>
          }
        </div>
        
        {
          type === LONGITS &&
          <ExistingLongitudinalHazards
            existingHazards={existingHazards}
            unit={unit}
            biomarker={biomarker}
          />
        }
        {
          type === HAZARDS &&
          <ExistingHazards
            existingHazards={existingHazards}
            unit={unit}
            biomarker={biomarker}
          />
        }
        {
          type === DISTRIBUTION &&
          <div> Under Construction </div>
        }
      </Fragment>
  ) 
}

export default AllExistingHazards;